//This port may change based on ur IDE configuration
var ApplicationDevPort = 58127;
//Check if we are running under nodejs then use ApplicationDevPort for web API otherwise use the application origin.
var BaseUrl =   window.location.host.indexOf('localhost') > -1 &&
    window.location.port === "8080" ?
    window.location.protocol + '//' + window.location.hostname + ":" + ApplicationDevPort :
    window.location.origin
export default {
    BaseUrl: BaseUrl,
    onLoggedOutRedirectTo: '/',
    onLoggedInRedirectTo: '/dashboard'
}



// WEBPACK FOOTER //
// ./src/application/index.js